import { useState, useCallback, useRef, useEffect } from 'react';
/**
 * A hook for copying text to the clipboard with visual feedback.
 * @param timeout - Duration in ms to show "copied" state (default: 2000ms)
 * @returns An object with `copied` state and `copyToClipboard` function
 */
export const useCopyToClipboard = (timeout = 2000) => {
    const [copied, setCopied] = useState(false);
    const timerRef = useRef(null);
    // Clean up timer on unmount
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);
    const copyToClipboard = useCallback(async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            // Clear any existing timer (handles rapid clicks)
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            // Start new timer
            timerRef.current = setTimeout(() => setCopied(false), timeout);
            return true;
        }
        catch (err) {
            console.error('Failed to copy:', err);
            return false;
        }
    }, [timeout]);
    return { copied, copyToClipboard };
};
